import { DeliveryPaymentMappingsQuery } from '@/features/pos/components/OrderFinalization/queries'
import { DeliveryPaymentMapping } from '@/features/pos/components/OrderFinalization/types'
import { transformDeliveryPaymentMapping } from '@/features/pos/components/OrderFinalization/utils/transforms'
import { useHandleQueryErrorWithToast } from '@/features/pos/hooks/useHandleQueryErrorWithToast'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

export const useDeliveryPaymentMappings = (): DeliveryPaymentMapping[] => {
    const { data, error, loading } = useQuery(DeliveryPaymentMappingsQuery)

    useHandleQueryErrorWithToast(error, loading)

    return useMemo(
        () =>
            data?.deliveryPaymentMappings
                .map(transformDeliveryPaymentMapping)
                .filter(({ paymentTypes }) => paymentTypes.length) ?? [],
        [data?.deliveryPaymentMappings]
    )
}
